<template>
  <v-layout row wrap>
    <v-flex xs6 sm4 md3 lg2 class="px-3" v-for="n in products.length" :key="n ">
      <v-card flat tile class="card-product">
        <v-card-media :src="products[n-1].pictures[0]
          " height="150px " @click="goProduct(products[n-1])">
          <v-card-actions v-if="editMode">
            <v-btn icon color="warning" @click.stop="editProduct(products[n-1])">
              <v-icon color="white">mode_edit</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card-media>
        <v-card-text>
          {{ products[n-1].title }}
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'Grid',
  props: {
    products: {
      type: Array,
      required: true
    },
    editMode: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {}
  },
  created () {},
  methods: {
    goProduct (product) {
      this.$store.state.product = product
      this.$router.push('/product')
    },
    editProduct (product) {
      this.$router.push({
        name: 'Upload',
        params: { product: product }
      })
    }
  }
}

</script>

<!-- Add "scoped " attribute to limit CSS to this component only -->
<style scoped>
  .card-product {
    border: 1px solid #f2f2f2 !important;
    -webkit-border-radius: 5px !important;
    -moz-border-radius: 5px !important;
    border-radius: 5px !important;
  }

  .card__text {
    padding: 8px !important;
  }

  .card__actions {
    align-items: unset !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Grid.vue